
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "NewOrleansCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NewOrleansCriteria.vue